import { ITagsState } from './tags.types'

export const TagsState: ITagsState = {
  loading: false,
  accountTags: [],
  normalisedTags: {
    byIds: {},
    allIds: []
  },
  showEditTagDialog: false,
  loaders: {
    applyingLabelsFilter: false
  },
  drawers: {
    invoiceTagSelection: false,
    labelFilterDrawer: false
  },
  accontLabels: [],
  LabelNodes: [],
  labelsFilter: []
}
